import { j as i } from "./jsx-runtime-3tyXYecC.mjs";
import { l as fe } from "./lodash-5ofSKtz3.mjs";
import * as v from "react";
import { useState as re, useEffect as ge } from "react";
import { f as t } from "./index-LyFokDcn.mjs";
import { I as ie } from "./icon-v2-DGtVEk7e.mjs";
import { u as xe, E as he, m as L } from "./tss-DN0acMKN.mjs";
import { M as be, d as ye } from "./constants-CnFYFetN.mjs";
import "./react-is.production.min-CoyJavcO.mjs";
import { g as K, c as q } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { m as N } from "./memoTheme-BzXKG_-k.mjs";
import { u as te } from "./useSlot-CRj3SG25.mjs";
import { g as Q } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { s as z, u as X, c as Y } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { P as ve } from "./Paper-J9MVFbwr.mjs";
import { u as Ce } from "./useControlled-ZIJRsfP8.mjs";
import { g as ne } from "./utils-LGPhgRZb.mjs";
import { u as Se, B as Fe } from "./ButtonBase-BIvHZGlt.mjs";
import { u as Ae } from "./useForkRef-C_4o__cU.mjs";
import { T as we } from "./Transition-4HZvpgGj.mjs";
import { c as Re } from "./index-DkZ16bcJ.mjs";
import { m as Z } from "./mui-DV6TgX2g.mjs";
import { I as $e } from "./ChevronLeft8x13-CHzitOe8.mjs";
function Me(e) {
  return K("MuiCollapse", e);
}
Q("MuiCollapse", ["root", "horizontal", "vertical", "entered", "hidden", "wrapper", "wrapperInner"]);
const je = (e) => {
  const {
    orientation: o,
    classes: r
  } = e, n = {
    root: ["root", `${o}`],
    entered: ["entered"],
    hidden: ["hidden"],
    wrapper: ["wrapper", `${o}`],
    wrapperInner: ["wrapperInner", `${o}`]
  };
  return Y(n, Me, r);
}, Ie = z("div", {
  name: "MuiCollapse",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: r
    } = e;
    return [o.root, o[r.orientation], r.state === "entered" && o.entered, r.state === "exited" && !r.in && r.collapsedSize === "0px" && o.hidden];
  }
})(N(({
  theme: e
}) => ({
  height: 0,
  overflow: "hidden",
  transition: e.transitions.create("height"),
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      height: "auto",
      width: 0,
      transition: e.transitions.create("width")
    }
  }, {
    props: {
      state: "entered"
    },
    style: {
      height: "auto",
      overflow: "visible"
    }
  }, {
    props: {
      state: "entered",
      orientation: "horizontal"
    },
    style: {
      width: "auto"
    }
  }, {
    props: ({
      ownerState: o
    }) => o.state === "exited" && !o.in && o.collapsedSize === "0px",
    style: {
      visibility: "hidden"
    }
  }]
}))), Te = z("div", {
  name: "MuiCollapse",
  slot: "Wrapper",
  overridesResolver: (e, o) => o.wrapper
})({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: "flex",
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), ke = z("div", {
  name: "MuiCollapse",
  slot: "WrapperInner",
  overridesResolver: (e, o) => o.wrapperInner
})({
  width: "100%",
  variants: [{
    props: {
      orientation: "horizontal"
    },
    style: {
      width: "auto",
      height: "100%"
    }
  }]
}), V = /* @__PURE__ */ v.forwardRef(function(o, r) {
  const n = X({
    props: o,
    name: "MuiCollapse"
  }), {
    addEndListener: s,
    children: u,
    className: d,
    collapsedSize: l = "0px",
    component: c,
    easing: p,
    in: C,
    onEnter: R,
    onEntered: $,
    onEntering: g,
    onExit: H,
    onExited: h,
    onExiting: S,
    orientation: m = "vertical",
    style: M,
    timeout: b = he.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent: F = we,
    ...j
  } = n, I = {
    ...n,
    orientation: m,
    collapsedSize: l
  }, x = je(I), f = xe(), G = Se(), A = v.useRef(null), W = v.useRef(), T = typeof l == "number" ? `${l}px` : l, k = m === "horizontal", w = k ? "width" : "height", D = v.useRef(null), _ = Ae(r, D), B = (a) => (y) => {
    if (a) {
      const E = D.current;
      y === void 0 ? a(E) : a(E, y);
    }
  }, ee = () => A.current ? A.current[k ? "clientWidth" : "clientHeight"] : 0, se = B((a, y) => {
    A.current && k && (A.current.style.position = "absolute"), a.style[w] = T, R && R(a, y);
  }), de = B((a, y) => {
    const E = ee();
    A.current && k && (A.current.style.position = "");
    const {
      duration: U,
      easing: O
    } = ne({
      style: M,
      timeout: b,
      easing: p
    }, {
      mode: "enter"
    });
    if (b === "auto") {
      const oe = f.transitions.getAutoHeightDuration(E);
      a.style.transitionDuration = `${oe}ms`, W.current = oe;
    } else
      a.style.transitionDuration = typeof U == "string" ? U : `${U}ms`;
    a.style[w] = `${E}px`, a.style.transitionTimingFunction = O, g && g(a, y);
  }), ce = B((a, y) => {
    a.style[w] = "auto", $ && $(a, y);
  }), le = B((a) => {
    a.style[w] = `${ee()}px`, H && H(a);
  }), ue = B(h), pe = B((a) => {
    const y = ee(), {
      duration: E,
      easing: U
    } = ne({
      style: M,
      timeout: b,
      easing: p
    }, {
      mode: "exit"
    });
    if (b === "auto") {
      const O = f.transitions.getAutoHeightDuration(y);
      a.style.transitionDuration = `${O}ms`, W.current = O;
    } else
      a.style.transitionDuration = typeof E == "string" ? E : `${E}ms`;
    a.style[w] = T, a.style.transitionTimingFunction = U, S && S(a);
  }), me = (a) => {
    b === "auto" && G.start(W.current || 0, a), s && s(D.current, a);
  };
  return /* @__PURE__ */ i.jsx(F, {
    in: C,
    onEnter: se,
    onEntered: ce,
    onEntering: de,
    onExit: le,
    onExited: ue,
    onExiting: pe,
    addEndListener: me,
    nodeRef: D,
    timeout: b === "auto" ? null : b,
    ...j,
    children: (a, y) => /* @__PURE__ */ i.jsx(Ie, {
      as: c,
      className: q(x.root, d, {
        entered: x.entered,
        exited: !C && T === "0px" && x.hidden
      }[a]),
      style: {
        [k ? "minWidth" : "minHeight"]: T,
        ...M
      },
      ref: _,
      ...y,
      // `ownerState` is set after `childProps` to override any existing `ownerState` property in `childProps`
      // that might have been forwarded from the Transition component.
      ownerState: {
        ...I,
        state: a
      },
      children: /* @__PURE__ */ i.jsx(Te, {
        ownerState: {
          ...I,
          state: a
        },
        className: x.wrapper,
        ref: A,
        children: /* @__PURE__ */ i.jsx(ke, {
          ownerState: {
            ...I,
            state: a
          },
          className: x.wrapperInner,
          children: u
        })
      })
    })
  });
});
V && (V.muiSupportAuto = !0);
const ae = /* @__PURE__ */ v.createContext({});
function Ee(e) {
  return K("MuiAccordion", e);
}
const J = Q("MuiAccordion", ["root", "heading", "rounded", "expanded", "disabled", "gutters", "region"]), ze = (e) => {
  const {
    classes: o,
    square: r,
    expanded: n,
    disabled: s,
    disableGutters: u
  } = e;
  return Y({
    root: ["root", !r && "rounded", n && "expanded", s && "disabled", !u && "gutters"],
    heading: ["heading"],
    region: ["region"]
  }, Ee, o);
}, He = z(ve, {
  name: "MuiAccordion",
  slot: "Root",
  overridesResolver: (e, o) => {
    const {
      ownerState: r
    } = e;
    return [{
      [`& .${J.region}`]: o.region
    }, o.root, !r.square && o.rounded, !r.disableGutters && o.gutters];
  }
})(N(({
  theme: e
}) => {
  const o = {
    duration: e.transitions.duration.shortest
  };
  return {
    position: "relative",
    transition: e.transitions.create(["margin"], o),
    overflowAnchor: "none",
    // Keep the same scrolling position
    "&::before": {
      position: "absolute",
      left: 0,
      top: -1,
      right: 0,
      height: 1,
      content: '""',
      opacity: 1,
      backgroundColor: (e.vars || e).palette.divider,
      transition: e.transitions.create(["opacity", "background-color"], o)
    },
    "&:first-of-type": {
      "&::before": {
        display: "none"
      }
    },
    [`&.${J.expanded}`]: {
      "&::before": {
        opacity: 0
      },
      "&:first-of-type": {
        marginTop: 0
      },
      "&:last-of-type": {
        marginBottom: 0
      },
      "& + &": {
        "&::before": {
          display: "none"
        }
      }
    },
    [`&.${J.disabled}`]: {
      backgroundColor: (e.vars || e).palette.action.disabledBackground
    }
  };
}), N(({
  theme: e
}) => ({
  variants: [{
    props: (o) => !o.square,
    style: {
      borderRadius: 0,
      "&:first-of-type": {
        borderTopLeftRadius: (e.vars || e).shape.borderRadius,
        borderTopRightRadius: (e.vars || e).shape.borderRadius
      },
      "&:last-of-type": {
        borderBottomLeftRadius: (e.vars || e).shape.borderRadius,
        borderBottomRightRadius: (e.vars || e).shape.borderRadius,
        // Fix a rendering issue on Edge
        "@supports (-ms-ime-align: auto)": {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    }
  }, {
    props: (o) => !o.disableGutters,
    style: {
      [`&.${J.expanded}`]: {
        margin: "16px 0"
      }
    }
  }]
}))), We = z("h3", {
  name: "MuiAccordion",
  slot: "Heading",
  overridesResolver: (e, o) => o.heading
})({
  all: "unset"
}), Ne = /* @__PURE__ */ v.forwardRef(function(o, r) {
  const n = X({
    props: o,
    name: "MuiAccordion"
  }), {
    children: s,
    className: u,
    defaultExpanded: d = !1,
    disabled: l = !1,
    disableGutters: c = !1,
    expanded: p,
    onChange: C,
    square: R = !1,
    slots: $ = {},
    slotProps: g = {},
    TransitionComponent: H,
    TransitionProps: h,
    ...S
  } = n, [m, M] = Ce({
    controlled: p,
    default: d,
    name: "Accordion",
    state: "expanded"
  }), b = v.useCallback((_) => {
    M(!m), C && C(_, !m);
  }, [m, C, M]), [F, ...j] = v.Children.toArray(s), I = v.useMemo(() => ({
    expanded: m,
    disabled: l,
    disableGutters: c,
    toggle: b
  }), [m, l, c, b]), x = {
    ...n,
    square: R,
    disabled: l,
    disableGutters: c,
    expanded: m
  }, f = ze(x), G = {
    transition: H,
    ...$
  }, A = {
    transition: h,
    ...g
  }, W = {
    slots: G,
    slotProps: A
  }, [T, k] = te("heading", {
    elementType: We,
    externalForwardedProps: W,
    className: f.heading,
    ownerState: x
  }), [w, D] = te("transition", {
    elementType: V,
    externalForwardedProps: W,
    ownerState: x
  });
  return /* @__PURE__ */ i.jsxs(He, {
    className: q(f.root, u),
    ref: r,
    ownerState: x,
    square: R,
    ...S,
    children: [/* @__PURE__ */ i.jsx(T, {
      ...k,
      children: /* @__PURE__ */ i.jsx(ae.Provider, {
        value: I,
        children: F
      })
    }), /* @__PURE__ */ i.jsx(w, {
      in: m,
      timeout: "auto",
      ...D,
      children: /* @__PURE__ */ i.jsx("div", {
        "aria-labelledby": F.props.id,
        id: F.props["aria-controls"],
        role: "region",
        className: f.region,
        children: j
      })
    })]
  });
});
function De(e) {
  return K("MuiAccordionDetails", e);
}
Q("MuiAccordionDetails", ["root"]);
const Be = (e) => {
  const {
    classes: o
  } = e;
  return Y({
    root: ["root"]
  }, De, o);
}, Pe = z("div", {
  name: "MuiAccordionDetails",
  slot: "Root",
  overridesResolver: (e, o) => o.root
})(N(({
  theme: e
}) => ({
  padding: e.spacing(1, 2, 2)
}))), Ve = /* @__PURE__ */ v.forwardRef(function(o, r) {
  const n = X({
    props: o,
    name: "MuiAccordionDetails"
  }), {
    className: s,
    ...u
  } = n, d = n, l = Be(d);
  return /* @__PURE__ */ i.jsx(Pe, {
    className: q(l.root, s),
    ref: r,
    ownerState: d,
    ...u
  });
});
function Ge(e) {
  return K("MuiAccordionSummary", e);
}
const P = Q("MuiAccordionSummary", ["root", "expanded", "focusVisible", "disabled", "gutters", "contentGutters", "content", "expandIconWrapper"]), Ue = (e) => {
  const {
    classes: o,
    expanded: r,
    disabled: n,
    disableGutters: s
  } = e;
  return Y({
    root: ["root", r && "expanded", n && "disabled", !s && "gutters"],
    focusVisible: ["focusVisible"],
    content: ["content", r && "expanded", !s && "contentGutters"],
    expandIconWrapper: ["expandIconWrapper", r && "expanded"]
  }, Ge, o);
}, qe = z(Fe, {
  name: "MuiAccordionSummary",
  slot: "Root",
  overridesResolver: (e, o) => o.root
})(N(({
  theme: e
}) => {
  const o = {
    duration: e.transitions.duration.shortest
  };
  return {
    display: "flex",
    minHeight: 48,
    padding: e.spacing(0, 2),
    transition: e.transitions.create(["min-height", "background-color"], o),
    [`&.${P.focusVisible}`]: {
      backgroundColor: (e.vars || e).palette.action.focus
    },
    [`&.${P.disabled}`]: {
      opacity: (e.vars || e).palette.action.disabledOpacity
    },
    [`&:hover:not(.${P.disabled})`]: {
      cursor: "pointer"
    },
    variants: [{
      props: (r) => !r.disableGutters,
      style: {
        [`&.${P.expanded}`]: {
          minHeight: 64
        }
      }
    }]
  };
})), Le = z("div", {
  name: "MuiAccordionSummary",
  slot: "Content",
  overridesResolver: (e, o) => o.content
})(N(({
  theme: e
}) => ({
  display: "flex",
  flexGrow: 1,
  margin: "12px 0",
  variants: [{
    props: (o) => !o.disableGutters,
    style: {
      transition: e.transitions.create(["margin"], {
        duration: e.transitions.duration.shortest
      }),
      [`&.${P.expanded}`]: {
        margin: "20px 0"
      }
    }
  }]
}))), Oe = z("div", {
  name: "MuiAccordionSummary",
  slot: "ExpandIconWrapper",
  overridesResolver: (e, o) => o.expandIconWrapper
})(N(({
  theme: e
}) => ({
  display: "flex",
  color: (e.vars || e).palette.action.active,
  transform: "rotate(0deg)",
  transition: e.transitions.create("transform", {
    duration: e.transitions.duration.shortest
  }),
  [`&.${P.expanded}`]: {
    transform: "rotate(180deg)"
  }
}))), Je = /* @__PURE__ */ v.forwardRef(function(o, r) {
  const n = X({
    props: o,
    name: "MuiAccordionSummary"
  }), {
    children: s,
    className: u,
    expandIcon: d,
    focusVisibleClassName: l,
    onClick: c,
    ...p
  } = n, {
    disabled: C = !1,
    disableGutters: R,
    expanded: $,
    toggle: g
  } = v.useContext(ae), H = (m) => {
    g && g(m), c && c(m);
  }, h = {
    ...n,
    expanded: $,
    disabled: C,
    disableGutters: R
  }, S = Ue(h);
  return /* @__PURE__ */ i.jsxs(qe, {
    focusRipple: !1,
    disableRipple: !0,
    disabled: C,
    component: "div",
    "aria-expanded": $,
    className: q(S.root, u),
    focusVisibleClassName: q(S.focusVisible, l),
    onClick: H,
    ref: r,
    ownerState: h,
    ...p,
    children: [/* @__PURE__ */ i.jsx(Le, {
      className: S.content,
      ownerState: h,
      children: s
    }), d && /* @__PURE__ */ i.jsx(Oe, {
      className: S.expandIconWrapper,
      ownerState: h,
      children: d
    })]
  });
}), Ke = L()(({ borderRadiuses: e, constructs: o, mixins: r, mode: n, spacing: s }, u) => ({
  root: {
    backgroundColor: "transparent",
    // needed so focus state doesn't move the accordion when it adds a border
    border: t.ifFeature("encore", "1px solid transparent"),
    borderRadius: t.ifFeature("encore", e[300]),
    boxShadow: "none",
    boxSizing: "border-box",
    "&:before": {
      display: "none"
    },
    outline: n === be.Dye ? `1px solid ${ye.main}` : void 0,
    /* @startCleanup encore */
    overflow: t.ifFeature("encore", void 0, u.hideDescriptionOnCollapse ? "hidden" : void 0),
    /* @endCleanup encore */
    "& + &": {
      marginTop: t.ifFeature("encore", s(1))
    },
    "&.Mui-expanded": {
      marginBottom: s(1)
    },
    // Override the disabled backgroundColor from MUI
    "&.Mui-disabled": {
      backgroundColor: t.ifFeature("encore", "transparent")
    },
    "&:has(.MuiAccordionSummary-root.Mui-focusVisible)": {
      borderColor: t.ifFeature("encore", o.border.primary.medium),
      boxShadow: t.ifFeature("encore", `0 0 0 4px ${r.alpha(o.border.primary.medium, 0.1)}`)
    }
  },
  disabled: {},
  expanded: {}
}));
function Qe({
  classes: e,
  containerRef: o,
  hideDescriptionOnCollapse: r,
  ...n
}) {
  const { classes: s } = Ke({ hideDescriptionOnCollapse: r }, { props: { classes: e } });
  return /* @__PURE__ */ i.jsx(Ne, { classes: s, ref: o, ...n });
}
const Xe = L()(({ spacing: e }) => ({
  root: {
    display: "flex",
    padding: e(0, 2, 3)
  }
}));
function Ye({ classes: e = {}, ...o }) {
  const { classes: r } = Xe(), { root: n, ...s } = e;
  return /* @__PURE__ */ i.jsx(Ve, { classes: { root: Re(r.root, n), ...s }, ...o });
}
const Ze = L()(({ constructs: e, palette: o, spacing: r, typography: n }, s) => ({
  root: {
    alignItems: "start",
    fill: t.ifFeature("encore", e.icon.neutral.medium),
    minHeight: t.ifFeature("encore", "50px", "62px"),
    padding: t.ifFeature("encore", r(1.5), s.hideDescriptionOnCollapse ? r(2, 2, 0) : r(2)),
    "&": {
      boxSizing: "border-box"
    },
    "&.MuiAccordionSummary-root.Mui-expanded": {
      fill: t.ifFeature("encore", e.icon.primary.strong),
      minHeight: t.ifFeature("encore", "50px", "62px")
    },
    "&.MuiAccordionSummary-root.Mui-disabled": {
      opacity: 1
    },
    "&.Mui-focusVisible": {
      backgroundColor: t.ifFeature("encore", "transparent"),
      fill: t.ifFeature("encore", e.icon.primary.strong)
    }
  },
  content: {
    margin: 0,
    "&.Mui-expanded": {
      margin: 0
    }
  },
  expandIconWrapper: {
    alignItems: "center",
    backgroundColor: "transparent",
    /* @startCleanup encore */
    fill: t.ifFeature("encore", void 0, o.grey[600]),
    /* @endCleanup encore */
    height: "auto",
    margin: r(0, 0, 0, 2),
    minHeight: t.ifFeature("encore", n.h5.lineHeight, n.h4.lineHeight),
    padding: 0,
    /* @startCleanup encore */
    transformOrigin: t.ifFeature("encore", void 0, "4px 7px"),
    /* @endCleanup encore */
    "&.Mui-expanded": {
      transform: "rotate(-90deg)"
    },
    ".MuiAccordionSummary-root:hover &": {
      fill: t.ifFeature("encore", e.icon.primary.strong)
    }
  },
  expanded: {},
  disabled: {}
}));
function _e({
  /* @startCleanup encore */
  classes: e,
  /* @endCleanup encore */
  hideDescriptionOnCollapse: o,
  ...r
}) {
  const { classes: n } = Ze(
    { hideDescriptionOnCollapse: o },
    /* @startCleanup encore */
    { props: { classes: e } }
    /* @endCleanup encore */
  );
  return /* @__PURE__ */ i.jsx(Je, { classes: n, ...r });
}
const eo = (e, o, r) => e ? t.ifFeature("encore", r.constructs.text.neutral.weak, r.palette.gray[600]) : o ? r.palette.primary.main : r.palette.gray[900], oo = (e, o, r) => e ? t.ifFeature("encore", r.constructs.icon.neutral.strong, r.palette.gray[600]) : o ? t.ifFeature("encore", r.constructs.icon.primary.strong, r.palette.primary.main) : t.ifFeature("encore", r.constructs.icon.neutral.xxStrong, r.palette.gray[900]), ro = (e, o) => e && o ? "auto" : e && !o ? "none" : "inherit", to = L()((e, o) => {
  const { constructs: r, palette: n, spacing: s, transitions: u, typography: d } = e, { disabled: l, expanded: c, hideDescriptionOnCollapse: p } = o;
  return {
    title: {
      display: "flex",
      gridColumn: "center-column"
    },
    defaultTitle: {
      color: eo(l, c, e),
      fontFamily: t.ifFeature("encore", d.h5.fontFamily, d.h4.fontFamily),
      fontSize: t.ifFeature("encore", d.h5.fontSize, d.h4.fontSize),
      fontWeight: t.ifFeature("encore", d.h5.fontWeight, d.h4.fontWeight),
      lineHeight: t.ifFeature("encore", d.h5.lineHeight, d.h4.lineHeight),
      margin: 0,
      overflow: "hidden",
      textOverflow: "ellipsis",
      transition: `color 150ms ${u.easing.easeInOut}`,
      whiteSpace: "nowrap",
      ".Mui-focusVisible &, .MuiAccordionSummary-root:hover &": {
        color: t.ifFeature("encore", r.text.primary.strong)
      }
    },
    headerContent: {
      alignItems: "center",
      display: "grid",
      gridColumnGap: s(1.25),
      gridTemplateColumns: "[left-column] auto [center-column] minmax(auto, 100%) [right-column] auto",
      width: "100%"
    },
    headerIcon: {
      display: "flex",
      fill: oo(l, c, e),
      /* @startCleanup encore */
      minWidth: t.ifFeature("encore", void 0, 20),
      /* @endCleanup encore */
      gridColumn: "left-column",
      transition: `fill 150ms ${u.easing.easeInOut}`,
      ".Mui-focusVisible &, .MuiAccordionSummary-root:hover &": {
        fill: t.ifFeature("encore", r.icon.primary.strong)
      }
    },
    headerRight: {
      display: "flex",
      gridColumn: "right-column",
      gridRow: 1
    },
    description: {
      background: "none",
      border: "none",
      color: n.gray[700],
      cursor: c ? "initial" : "inherit",
      fontSize: d.small.fontSize,
      gridColumn: t.ifFeature("encore", "center-column", p ? "1 / span 3" : "center-column"),
      lineHeight: d.small.lineHeight,
      opacity: p && !c ? 0 : 1,
      /* @startCleanup encore */
      padding: t.ifFeature("encore", void 0, p ? s(0, 0, 2, 3.75) : "inherit"),
      /* @endCleanup encore */
      pointerEvents: ro(p, c),
      textAlign: "inherit",
      transition: `opacity 150ms ${u.easing.easeInOut}`,
      userSelect: c ? "text" : "inherit"
    }
  };
});
function no({
  disabled: e,
  headerIcon: o,
  title: r,
  description: n,
  expanded: s,
  headerRight: u,
  hideDescriptionOnCollapse: d,
  id: l
}) {
  const { classes: c } = to({ disabled: e, expanded: s, hideDescriptionOnCollapse: d });
  return /* @__PURE__ */ i.jsxs("div", { "aria-level": 1, className: c.headerContent, id: l, role: "heading", children: [
    t.ifFeature(
      "encore",
      o && typeof o == "string" && /* @__PURE__ */ i.jsx("div", { className: c.headerIcon, children: /* @__PURE__ */ i.jsx(ie, { name: o, size: 20 }) }),
      o && /* @__PURE__ */ i.jsx("div", { className: c.headerIcon, children: o })
    ),
    r && /* @__PURE__ */ i.jsx("div", { className: c.title, children: typeof r == "string" ? /* @__PURE__ */ i.jsx("div", { className: c.defaultTitle, children: r }) : r }),
    n && /* @__PURE__ */ i.jsx("div", { className: c.description, children: t.ifFeature(
      "encore",
      /* @__PURE__ */ i.jsx(
        V,
        {
          collapsedSize: 0,
          id: `accordion-description-${l}`,
          in: !d || s,
          timeout: "auto",
          children: n
        }
      ),
      n
    ) }),
    u && /* @__PURE__ */ i.jsx("div", { className: c.headerRight, children: u })
  ] });
}
const io = L()(() => ({
  body: {},
  description: {},
  disabled: {},
  expanded: {},
  expandIcon: {},
  header: {},
  headerContent: {},
  headerIcon: {},
  headerRight: {},
  hideDescriptionOnCollapse: {},
  root: {},
  title: {}
})), ao = Z(({ borderRadiuses: e, constructs: o, palette: r, spacing: n }) => ({
  root: {
    backgroundColor: r.common.white,
    borderBottomColor: t.ifFeature("encore", o.border.neutral.xWeak),
    borderBottomWidth: t.ifFeature("encore", "1px"),
    /* @startCleanup encore */
    borderColor: t.ifFeature("encore", void 0, r.grey[300]),
    /* @endCleanup encore */
    borderRadius: e[0],
    borderStyle: "solid",
    /* @startCleanup encore */
    borderWidth: t.ifFeature("encore", void 0, "1px 0"),
    /* @endCleanup encore */
    boxShadow: "none",
    boxSizing: "border-box",
    /* @startCleanup encore */
    "&:not(:last-child)": {
      borderBottom: t.ifFeature("encore", void 0, 0)
    },
    /* @endCleanup encore */
    "& + &": {
      margin: t.ifFeature("encore", n(0))
    },
    "&:has(.MuiAccordionSummary-root.Mui-focusVisible)": {
      borderRadius: t.ifFeature("encore", e[300])
    },
    /* @startCleanup encore */
    "&$expanded": {
      margin: t.ifFeature("encore", void 0, 0)
    }
    /* @endCleanup encore */
  },
  disabled: {},
  expanded: {}
})), so = Z(({ borderRadiuses: e, constructs: o, mixins: { border: r }, palette: n }) => ({
  root: {
    backgroundColor: t.ifFeature("encore", o.surface.neutral.xxWeak, n.grey[100]),
    borderRadius: t.ifFeature("encore", e[300], 8),
    "&$disabled": {
      // Need to specify the same color here as on `root`
      // to override the disabled backgroundColor set by MUI
      backgroundColor: t.ifFeature("encore", o.surface.neutral.xxWeak)
    },
    "&:has(.MuiAccordionSummary-root.Mui-focusVisible)": {
      backgroundColor: o.surface.neutral.inverted
    },
    "&:hover:not(&$expanded)": {
      // Will change the border color on hover if the accordion is not expanded
      borderColor: t.ifFeature("encore", o.border.neutral.weak)
    }
  },
  expanded: {
    backgroundColor: n.common.white,
    border: r(1, n.primary.lighter)
  },
  disabled: {}
})), co = Z(({ borderRadiuses: e, constructs: o, spacing: r, palette: n }) => ({
  root: {
    maxHeight: "40px",
    transition: "all .2s ease-in-out",
    border: "0px solid transparent",
    "& + &": {
      marginTop: t.ifFeature("encore", r(1))
    }
  },
  expanded: {
    margin: "0 0 8px 0!important",
    // this maxHeight has to be a pixel value in order for the transition
    // animation to work. unset and fit-content make the collapsing animation
    // look ugly
    maxHeight: "9999999999px",
    border: `1px solid ${t.ifFeature("encore", o.border.neutral.xWeak, n.gray[200])}`,
    borderRadius: t.ifFeature("encore", e[200], "4px"),
    "& $header": {
      backgroundColor: t.ifFeature("encore", o.surface.neutral.xWeak, n.gray[200]),
      display: "flex",
      alignItems: "center",
      borderTopLeftRadius: t.ifFeature("encore", e[200], "4px"),
      borderTopRightRadius: t.ifFeature("encore", e[200], "4px")
    },
    transition: "all .2s ease-in-out"
  },
  header: {
    padding: "0px 12px",
    minHeight: "40px!important"
  },
  body: {
    padding: "0px 32px",
    margin: "-1px 0px -1px 0px"
  }
})), lo = Z(({ borderRadiuses: e, constructs: o, mixins: { alpha: r }, spacing: n }) => ({
  root: {
    border: "none",
    boxShadow: "none !important"
  },
  expanded: {
    "& $header": {
      minHeight: "auto !important"
    }
  },
  header: {
    alignItems: "center",
    justifyContent: "normal",
    minHeight: "auto",
    padding: 0,
    "&:focus-visible": {
      "&:after": {
        border: `1px solid ${o.border.primary.medium}`,
        borderRadius: e[200],
        bottom: -4,
        boxShadow: `0 0 0 4px ${r(o.border.primary.medium, 0.1)}`,
        content: "''",
        display: "block",
        left: -8,
        position: "absolute",
        right: -8,
        top: -4,
        transition: "all 75ms"
      }
    }
  },
  headerContent: {
    flex: "0 1 auto"
  },
  body: {
    padding: `${n(2)} 0 0`
  }
})), Eo = ({
  biId: e,
  /* @startCleanup encore */
  className: o,
  classes: r,
  /* @endCleanup encore */
  children: n,
  /* @startCleanup encore */
  collapsedSize: s = "62px",
  /* @endCleanup encore */
  defaultExpanded: u,
  description: d,
  disabled: l,
  expandIcon: c,
  expanded: p,
  headerContent: C,
  headerIcon: R,
  headerRight: $,
  hideDescriptionOnCollapse: g = !1,
  hideExpandIcon: H = !1,
  onChange: h,
  /* @startCleanup encore */
  sx: S,
  /* @endCleanup encore */
  title: m,
  variant: M,
  ...b
}) => {
  const [F] = re(typeof m == "string" ? m.replaceAll(" ", "-") : fe.uniqueId()), [j, I] = re(p ?? u), x = {
    border: ao(),
    card: so(),
    compact: co(),
    minimal: lo()
  }, { classes: f, cx: G } = io(void 0, {
    props: {
      classes: t.ifFeature("encore", x[M || ""], {
        ...x[M || ""],
        ...r
      })
    }
  });
  ge(() => {
    typeof p == "boolean" && I(p);
  }, [p]);
  const A = $e, W = !H && {
    expandIcon: c || t.ifFeature("encore", !l && /* @__PURE__ */ i.jsx(ie, { name: "angle-left-regular", size: 20 }), /* @__PURE__ */ i.jsx(A, { "aria-hidden": "true" }))
  }, T = [
    /* @__PURE__ */ i.jsx(
      _e,
      {
        "aria-controls": `accordion-control-${F}`,
        "aria-disabled": l,
        classes: { root: f.header, content: f.headerContent, expandIconWrapper: f.expandIcon },
        "data-bi-id": e,
        hideDescriptionOnCollapse: g,
        id: `accordion-header-wrapper-${F}`,
        role: "button",
        ...W,
        children: C || /* @__PURE__ */ i.jsx(
          no,
          {
            description: d,
            disabled: l,
            expanded: j,
            headerIcon: R,
            headerRight: $,
            hideDescriptionOnCollapse: g,
            id: `accordion-header-${F}`,
            title: m
          }
        )
      },
      "header"
    ),
    /* @startCleanup encore */
    /* For Jade, if the accordion does NOT hide the description on Collapse, we use this Transition component. */
    /* @endCleanup encore */
    /* @__PURE__ */ i.jsx(V, { in: t.ifFeature("encore", j, g || j), timeout: "auto", children: /* @__PURE__ */ i.jsx(Ye, { classes: { root: f.body }, children: n }) }, "contents")
  ];
  return /* @__PURE__ */ i.jsx(
    Qe,
    {
      classes: { root: f.root, disabled: f.disabled },
      className: G(
        /* @startCleanup encore */
        t.ifFeature("encore", void 0, o),
        /* @endCleanup encore */
        {
          [f.expanded]: j,
          [f.hideDescriptionOnCollapse]: g
        }
      ),
      defaultExpanded: u,
      disabled: l,
      expanded: p,
      hideDescriptionOnCollapse: g,
      id: `accordion-root-${F}`,
      onChange: (k, w) => {
        I(p ?? w), h == null || h(w, k);
      },
      square: !0,
      sx: t.ifFeature("encore", void 0, S),
      TransitionProps: { in: !0 },
      ...b,
      "data-fabric-component": "Accordion",
      children: t.ifFeature(
        "encore",
        T,
        // If the accordion hides the description on Collapse, we use this Transition component.
        /* @__PURE__ */ i.jsx(
          V,
          {
            collapsedSize: s,
            id: `section-content-${F}`,
            in: !g || j,
            timeout: "auto",
            children: T
          }
        )
      )
    }
  );
};
export {
  Eo as A,
  V as C,
  so as a,
  co as b,
  lo as c,
  ao as u
};
//# sourceMappingURL=accordion-Bkf3z0q-.mjs.map
